import { useState, useRef } from "react";

import { API_URL, getValFromLS } from "../../helpers";

import Input from "../../components/Input";
import Checkbox from "../../components/Checkbox";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

const LinksForm1 = ({ handleStatus }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e = null, id = 0) => {
		if (e) {
			e.preventDefault();
		} else {
		}
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/admin/links1`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "new") {
				data.append(key, value ? "1" : "0");
			} else {
				data.append(key, value);
			}
		});
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleStatus({ ...json });
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			className="well"
		>
			<div className="form-group">
				<Input
					name="sponsorId"
					label="Sponsor ID"
					reqd={true}
					value={""}
					update={handleUpdate}
					errors={errors}
					note=""
				/>

				<div className="empty" />
			</div>

			<div
				className="form-group checkbox"
				style={{ marginTop: "0", marginBottom: "15px" }}
			>
				<Checkbox
					name="new"
					label="Check if you have confirmed this organization does not have a sponsor ID and you wish to add it as a new one."
					checked={false}
					click={handleUpdate}
				/>
			</div>

			{names.new && (
				<div className="form-group">
					<Input
						name="fname"
						label="First Name"
						reqd={true}
						value={names.fname}
						update={handleUpdate}
						errors={errors}
						note=""
					/>

					<Input
						name="lname"
						label="Last Name"
						reqd={true}
						value={names.lname}
						update={handleUpdate}
						errors={errors}
						note=""
					/>
				</div>
			)}

			{names.new && (
				<div className="form-group">
					<Input
						name="organization"
						label="Organization Name"
						reqd={true}
						value={""}
						update={handleUpdate}
						errors={errors}
						note=""
					/>

					<Input
						name="email"
						label="Email Address"
						reqd={true}
						value={names.email}
						update={handleUpdate}
						errors={errors}
						note=""
					/>
				</div>
			)}

			<div className="msg-submit" style={{ marginTop: "30px" }}>
				{msg.type && <Msg data={msg} />}

				<div
					className={
						msg.type === "working" ||
						msg.type === "notice" ||
						msg.type === "success"
							? "hidden"
							: "submit-container"
					}
				>
					<Submit submit="Check Registration" />
				</div>
			</div>
		</form>
	);
};

export default LinksForm1;
